module.exports = __webpack_public_path__ + "img/Group 318.5ddd5412.png";